import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useUserOrgPermissions = (userId: number, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["userOrgPermissions", userId],
    queryFn: async () => await apiClient.getUserOrgPermissions({ queries: { user_id: userId } }),
    ...options,
  });
};
